module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.6.2-126.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.6.2.md
// module id = 542
// module chunks = 261